import { FormType } from '../../../../form-types';
import { MetabolicTadalafilFollowupFieldAnswers } from './questions';

const metabolicTadalafilFollowup: FormType<MetabolicTadalafilFollowupFieldAnswers> =
  {
    name: 'Tadalafil Follow-up Consultation',
    questions: [
      {
        key: 'metabolicTadalafilFollowup_contraindications',
        next: {
          switch: [
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.mi_within_last_6_months':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.hypertrophic_cardiomyopathy_or_uncontrolled_hf':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.heart_arrhythmia_or_qt_prolongation':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.stroke_or_brain_hemorrhage_within_last_12_months':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.sickle_cell_anemia_or_myeloma_or_leukemia':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.retinitis_pigmentosa_or_sudden_vision_loss':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.pulmonary_hypertension':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            },
            {
              condition: {
                'metabolicTadalafilFollowup_contraindications.penile_curve_or_painful_erections_or_tight_foreskin':
                  true
              },
              key: 'metabolicTadalafilFollowup_ineligible'
            }
          ],
          els: 'metabolicTadalafilFollowup_cardiovascularSymptoms'
        }
      },
      {
        key: 'metabolicTadalafilFollowup_cardiovascularSymptoms',
        next: {
          condition: {
            'metabolicTadalafilFollowup_cardiovascularSymptoms.none': true
          },
          key: 'metabolicTadalafilFollowup_consent',
          els: 'metabolicTadalafilFollowup_ineligible'
        }
      },
      {
        key: 'metabolicTadalafilFollowup_consent',
        next: {
          switch: [
            {
              condition: {
                'metabolicTadalafilFollowup_consent.non_consent': true
              },
              key: 'metabolicTadalafilFollowup_didNotConsent'
            }
          ],
          els: 'metabolicTadalafilFollowup_complete'
        }
      },
      'metabolicTadalafilFollowup_complete',
      'metabolicTadalafilFollowup_ineligible',
      'metabolicTadalafilFollowup_didNotConsent'
    ]
  };

export default metabolicTadalafilFollowup;
